import React from 'react';
import { Route, Redirect } from 'react-router-dom';
// import { Session } from 'bc-react-session';
import { SessionProvider } from 'providers';

function PrivateRoute({ component: Component, ...rest }) {
    const session = SessionProvider.get();
    return (
        <Route
            {...rest}
            render={props =>
                session.isValid ? (
                    <Component {...props} />
                ) : (
                    <Redirect to="/cpanel/login" />
                )
            }
        />
    );
}

export default PrivateRoute;